import { useState } from "react";
import { Col, Form, Input, Select, Space } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { HistorialNumeroSerieModal } from "./HistorialNumeroSerieModal";
import { normalizarBusqueda } from "../../shared/normalizarBusqueda";
import { AyudaContextual } from "../../../../components/avisos/AyudaContextual";

const { Option } = Select;

const esCampoNumeroSerie = (label) => {
  const labelCompacto = normalizarBusqueda(label).replace(/\s/g, "");
  return labelCompacto === "numeroserie" || labelCompacto === "numerodeserie";
};

export const CampoServicioItem = ({ campo, campaniaID, value, opciones, onCampoChange }) => {
  const [historialVisible, setHistorialVisible] = useState(false);
  const labelCampo = Number(campaniaID) === 61 && Number(campo.id) === 513 ? (
    <Space size={6}>
      <span>{campo.label}</span>
      <AyudaContextual>
        <p>Coloca en el apartado de Estatus de póliza:</p>
        <ul className="ayuda-contextual__lista">
          <li>Vigente</li>
          <li>No vigente (en caso de que se encuentre vencida)</li>
        </ul>
        <p className="ayuda-contextual__texto">Solicita el número de serie vehicular completo.</p>
      </AyudaContextual>
    </Space>
  ) : campo.label;

  if (campo.tipo === "texto") {
    const esNumeroSerie = esCampoNumeroSerie(campo.label)
    const longitudesValidas = esNumeroSerie ? [16, 17] : null

    const esInvalido =
      longitudesValidas !== null &&
      value &&
      !longitudesValidas.includes(value.length)

    const mensajeError = esInvalido
      ? `Debe tener 16 o 17 caracteres`
      : ""

    const label = esNumeroSerie ? (
      <span className="campo-servicio-item__label-action">
        {labelCampo}
        <a
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            setHistorialVisible(true);
          }}
          style={{ cursor: 'pointer' }}
        >
          <SearchOutlined />
        </a>
      </span>
    ) : labelCampo;

    return (
      <Col xs={24} sm={8} key={campo.id}>
        <Form.Item
          label={label}
          required={campo.esRequerido}
          validateStatus={esInvalido ? "error" : ""}
          help={mensajeError}
        >
          <Input
            placeholder={campo.label}
            value={value || ""}
            onChange={(e) => onCampoChange(campo.id, e.target.value)}
            status={esInvalido ? "error" : ""}
          />
        </Form.Item>
        {esNumeroSerie && (
          <HistorialNumeroSerieModal
            open={historialVisible}
            numeroSerieInicial={value || ""}
            onClose={() => setHistorialVisible(false)}
          />
        )}
      </Col>
    );
  }

  if (campo.tipo === "lista") {
    return (
      <Col xs={24} sm={8} key={campo.id}>
        <Form.Item label={labelCampo} required={campo.esRequerido}>
          <Select
            placeholder={`Seleccione ${campo.label}`}
            value={value}
            onChange={(val) => onCampoChange(campo.id, val)}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              normalizarBusqueda(option?.children).includes(normalizarBusqueda(input))
            }
            style={{ width: "100%" }}
          >
            {(opciones || []).map((opcion) => (
              <Option key={opcion.valor} value={opcion.valor}>
                {opcion.texto}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
    );
  }

  return null;
};
